<div class="flex flex-col gap-2">
  @if (label()) {
    <label class="truncate" [ngClass]="smallLabel() ? 'text-sm' : ''" [for]="id()">
      {{ label() | transloco }}
      @if (isRequired) {
        <span class="text-red" [ngClass]="smallLabel() ? 'text-sm' : ''">*</span>
      }
    </label>
  }
  @if (disabledSignal()?.()) {
    <input pInputText [value]="valueAsDisabledComputed()" [disabled]="'true'" />
  } @else {
    @if (type() === 'number') {
      <p-inputNumber
        [id]="id()"
        [attr.data-testid]="id() + '-input'"
        [formControlName]="fieldName()"
        [min]="effectiveMin"
        [max]="effectiveMax"
        [showButtons]="showButtons()"
        [step]="step()"
        [mode]="mode() === 'decimal' ? 'decimal' : undefined"
        [minFractionDigits]="mode() === 'decimal' ? 0 : undefined"
        [maxFractionDigits]="mode() === 'decimal' ? maxFractionDigits() : undefined"
        [placeholder]="placeholder() || ''"
        [ngClass]="{'p-invalid': form.get(fieldName())?.invalid && form.get(fieldName())?.touched}"
        fluid="true"
      >
      </p-inputNumber>
    } @else if (type() === 'datePicker') {
      <p-datePicker
        [id]="id()"
        [attr.data-testid]="id() + '-input'"
        [formControlName]="fieldName()"
        [ngClass]="{'p-invalid': form.get(fieldName())?.invalid && form.get(fieldName())?.touched}"
        [showButtonBar]="true"
        dateFormat="dd/mm/yy"
        class="w-full"
        appendTo="body"
      ></p-datePicker>
    } @else if (type() === 'dropdownSelect') {
      <p-select
        [id]="id()"
        [attr.data-testid]="id() + '-input'"
        [formControlName]="fieldName()"
        [options]="dropDownOptions()"
        [placeholder]="placeholder() || ''"
        [ngClass]="{
          'ng-invalid ng-dirty': form.get(fieldName())?.invalid && form.get(fieldName())?.touched,
        }"
        class="w-full"
        appendTo="body"
      ></p-select>
    } @else if (type() === 'dropdownSelectV2') {
      <app-select
        [id]="id()"
        [attr.data-testid]="id() + '-input'"
        [options]="dropDownOptionsV2()"
        [placeholder]="placeholder() || ''"
        [ngClass]="{
          'ng-invalid ng-dirty': form.get(fieldName())?.invalid && form.get(fieldName())?.touched,
        }"
        class="w-full"
        [disabled]="disabledSignal()?.() || false"
        [formControlName]="fieldName()"
        [relationshipId]="selectedOptionId()"
      ></app-select>
    } @else if (type() === 'textarea') {
      <textarea
        pTextarea
        [id]="id()"
        [attr.data-testid]="id() + '-input'"
        [formControlName]="fieldName()"
        [placeholder]="placeholder() || ''"
        [ngClass]="{'p-invalid': form.get(fieldName())?.invalid && form.get(fieldName())?.touched}"
        [rows]="5"
        class="w-full"
      ></textarea>
    } @else if (type() === 'file') {
      <p-fileupload
        [id]="id()"
        [attr.data-testid]="id() + '-input'"
        mode="basic"
        chooseLabel="Browse"
        [accept]="accept() || ''"
        (onSelect)="onFileSelect($event)"
        [auto]="true"
        [disabled]="form.get(fieldName())?.disabled"
        class="w-full"
      ></p-fileupload>
    } @else if (type() === 'selectButton') {
      <p-selectButton
        [id]="id()"
        [attr.data-testid]="id() + '-input'"
        [formControlName]="fieldName()"
        [options]="selectTranslatedOptions()"
        optionValue="id"
        [ngClass]="{'p-invalid': form.get(fieldName())?.invalid && form.get(fieldName())?.touched}"
        class="w-full"
      >
        <ng-template #item let-item>
          {{ item.translations | translateDirectus }}
          @if (item.tooltip?.key) {
            <app-directus-tooltip
              tooltipStyleClass="tooltip-bg-second-level"
              [tooltipKey]="item.tooltip?.key"
            ></app-directus-tooltip>
          }
        </ng-template>
      </p-selectButton>
    } @else if (type() !== 'password' && type() !== 'passwordRepeat') {
      <input
        pInputText
        [id]="id()"
        [attr.data-testid]="id() + '-input'"
        [type]="type()"
        [formControlName]="fieldName()"
        [placeholder]="placeholder() || ''"
        [ngClass]="{'p-invalid': form.get(fieldName())?.invalid && form.get(fieldName())?.touched}"
      />
    } @else if (type() === 'passwordRepeat') {
      <input
        pInputText
        [id]="id()"
        [attr.data-testid]="id() + '-input'"
        [formControlName]="fieldName()"
        type="password"
        [placeholder]="placeholder() || (label() | transloco)"
        [ngClass]="{'p-invalid': form.get(fieldName())?.invalid && form.get(fieldName())?.touched}"
      />
    } @else {
      <p-password
        [id]="id()"
        [attr.data-testid]="id() + '-input'"
        [formControlName]="fieldName()"
        [feedback]="true"
        [toggleMask]="true"
        [strongRegex]="strongRegex"
        type="password"
        promptLabel=" "
        weakLabel="{{ 'account.register.weakLabel' | transloco }}"
        mediumLabel="{{ 'account.register.mediumLabel' | transloco }}"
        strongLabel="{{ 'account.register.strongLabel' | transloco }}"
        [placeholder]="placeholder() || (label() | transloco)"
        [ngClass]="{
          'ng-invalid ng-dirty': form.get(fieldName())?.invalid && form.get(fieldName())?.touched,
        }"
      >
        <ng-template #footer>
          <p-divider />
          <ul class="pl-2 ml-2 my-0 leading-normal">
            <li>{{ 'account.register.minLowercase' | transloco }}</li>
            <li>{{ 'account.register.minUppercase' | transloco }}</li>
            <li>{{ 'account.register.minNumeric' | transloco }}</li>
            <li>{{ 'account.register.minCharacters' | transloco }}</li>
            <li>{{ 'account.register.minSpecialCharacter' | transloco }}</li>
          </ul>
        </ng-template>
      </p-password>
    }

    @if (!disabledSignal()?.() && form.get(fieldName())?.touched && showError()) {
      @if (form.get(fieldName())?.errors?.['required']) {
        <p-message
          severity="error"
          variant="simple"
          size="small"
          [attr.data-testid]="id() + '-required-error'"
        >
          {{ 'account.validation.requiredField' | transloco }}
        </p-message>
      } @else if (form.get(fieldName())?.errors?.['email']) {
        <p-message
          severity="error"
          variant="simple"
          size="small"
          [attr.data-testid]="id() + '-invalid-error'"
        >
          {{ 'account.validation.invalidEmail' | transloco }}
        </p-message>
      } @else if (form.get(fieldName())?.errors?.['phoneNumber']) {
        <p-message
          severity="error"
          variant="simple"
          size="small"
          [attr.data-testid]="id() + '-invalid-error'"
        >
          {{ 'account.validation.invalidPhoneNumber' | transloco }}
        </p-message>
      } @else if (form.get(fieldName())?.errors?.['minlength']) {
        <p-message
          severity="error"
          variant="simple"
          size="small"
          [attr.data-testid]="id() + '-minCharacters-required-error'"
        >
          {{ 'account.register.minCharacters' | transloco }}
        </p-message>
      } @else if (form.get(fieldName())?.errors?.['maxlength']; as maxLengthError) {
        <p-message
          severity="error"
          variant="simple"
          size="small"
          [attr.data-testid]="id() + '-maxLength-error'"
        >
          {{
            'account.validation.maxLength' | transloco: {maxLength: maxLengthError.requiredLength}
          }}
        </p-message>
      } @else if (form.get(fieldName())?.errors?.['password']) {
        <p-message
          severity="error"
          variant="simple"
          size="small"
          [attr.data-testid]="id() + '-invalid-error'"
        >
          {{ 'account.validation.invalidPassword' | transloco }}
        </p-message>
      } @else if (form.get(fieldName())?.errors?.['passwordMismatch']) {
        <p-message
          severity="error"
          variant="simple"
          size="small"
          [attr.data-testid]="id() + '-passwordMismatch-error'"
        >
          {{ 'account.validation.passwordMismatch' | transloco }}
        </p-message>
      } @else if (form.get(fieldName())?.errors?.['nameExists']) {
        <p-message
          severity="error"
          variant="simple"
          size="small"
          [attr.data-testid]="id() + '-nameExists-error'"
        >
          {{ 'nameExists' | transloco }}
        </p-message>
      } @else if (form.get(fieldName())?.errors?.['apiError']) {
        <p-message
          severity="error"
          variant="simple"
          size="small"
          [attr.data-testid]="id() + '-apiError-error'"
        >
          {{ form.get(fieldName())?.errors?.['apiError'] }}
        </p-message>
      } @else if (
        form.get(fieldName())?.errors && Object.keys(form.get(fieldName())?.errors || {}).length > 0
      ) {
        <p-message
          severity="error"
          variant="simple"
          size="small"
          [attr.data-testid]="id() + '-error'"
        >
          {{ customErrorKey() ? (customErrorKey() | transloco) : ('invalidField' | transloco) }}
        </p-message>
      }
    }
  }
</div>
